export default __webpack_public_path__ + "static/media/logo.aaa9470c.png";